import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "us-east-2_ljXQGG0cA",
    ClientId: "5l37evobi9ml9fuqq76tjpmdkr"
}

export default new CognitoUserPool(poolData)